import Navbar from "@/components/Navbar";
import MobileBottomNav from "@/components/MobileBottomNav";
import { Toaster } from "@/components/ui/sonner";

export default function Layout({ children, dark = false }) {
  return (
    <div className={`min-h-screen ${dark ? "bg-slate-950 text-white" : "bg-slate-50 text-slate-900"}`}>
      <Navbar />
      <main className="pb-20 sm:pb-0">{children}</main>
      <MobileBottomNav />
      <Toaster position="top-right" richColors />
    </div>
  );
}
